import clsx from 'clsx'
import type { PropsWithChildren, ReactElement } from 'react'
import {
  wrapper,
  wrapperCenter,
  wrapperRight,
  wrapperSpaceBetween
} from './ButtonGroup.css'

export const ButtonGroup = ({
  children,
  className,
  align = 'left'
}: PropsWithChildren<{
  className?: string | string[]
  align?: 'left' | 'center' | 'right' | 'spaceBetween'
}>): ReactElement | null => {
  if (Array.isArray(children) && children.length === 0) {
    return null
  }
  return (
    <div
      className={clsx(
        wrapper,
        className,
        align === 'spaceBetween' && wrapperSpaceBetween,
        align === 'center' && wrapperCenter,
        align === 'right' && wrapperRight
      )}
    >
      {children}
    </div>
  )
}
